import { LabelledRow, Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import SmallDetails from "components/SmallDetails/SmallDetails";
import OptionalNumberInput from "components/ValidatedFields/OptionalNumberInput";
import InvoiceExportMaskDropdown from "components/dropdowns/reactselect/InvoiceExportMaskDropdown";
import { Loading } from "components/panels";
import React, { useEffect, useState } from "react";

interface Props {
  isOpen: boolean
  onClose: (changed: boolean) => void
  bookkeepingId: number | null;
}

export const BookkeepingConfigureModal = (props: Props) => {
  const [bookkeeping, setBookkeeping] = useState<server.dto.Bookkeeping | null>(null);
  const exportMask = serverReference.exportMasks.find(m => m.value === bookkeeping?.exportMask);
  const [isLoadingBookkeeping, setIsLoadingBookkeeping] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const onClose = (changed: boolean) => {
    props.onClose(changed);
    setIsLoadingBookkeeping(true);
  }

  const fetchConfiguration = async (bookkeepingId: number) => {
    setIsLoadingBookkeeping(true);
    const res = await window.CoreApi.Bookkeeping.GetItem(bookkeepingId);
    //TODO: We want to make sure we also handle possible errors coming from API here
    setIsLoadingBookkeeping(false);
    setBookkeeping(res.data.data);
  }

  const saveConfiguration = async () => {
    if (!bookkeeping || !props.bookkeepingId) {
      return;
    }

    const dto: server.dto.ConfigureBookkeepingForAdminOneInstruction = {
      bookkeepingId: props.bookkeepingId,
      exportMask: bookkeeping.exportMask,
      storecoveLegalEntityId: bookkeeping.storecoveLegalEntityId,
    }

    setIsSaving(true);
    await window.CoreApi.Bookkeeping.ConfigureBookkeepingForAdminOne(dto);
    setIsSaving(false);
    onClose(true);
  }

  useEffect(() => {
    if (props.bookkeepingId) {
      fetchConfiguration(props.bookkeepingId);
    }
  }, [props.bookkeepingId]);

  return <Modal
    isOpen={props.isOpen}
    handleClose={() => onClose(false)}
    title="Configure Bookkeeping"
    width="small"
  >
    <div>
      {isLoadingBookkeeping && <Loading />}
      {!isLoadingBookkeeping && <table className="s1_table bordergrid gray">
        <tbody>
          <LabelledRow label={RESX.Bookkeeping.resxBookkeeping}>
            <SmallDetails
              label={bookkeeping?.name}
              subLabel={bookkeeping?.code}
            />
          </LabelledRow>
          <LabelledRow label={RESX.InvoiceExport.ExportMask}>
            <InvoiceExportMaskDropdown
              options={serverReference.exportMasks}
              value={exportMask}
              onChange={exportMask => setBookkeeping({ ...bookkeeping, exportMask: exportMask.value })}
            />
          </LabelledRow>

          <LabelledRow label={"Storecove LegalEntityId"}>
            <OptionalNumberInput
              canBeEmpty
              width={90}
              decimalPoints={0}
              value={bookkeeping?.storecoveLegalEntityId}
              onChange={(v) => setBookkeeping({ ...bookkeeping, storecoveLegalEntityId: v })}
            />
          </LabelledRow>
        </tbody>
      </table>}
    </div>
    <div className="flex margin-top-bigger">
      <div className="grow1"></div>
      <ButtonPrimary
        loading={isSaving}
        disabled={isSaving || isLoadingBookkeeping}
        label={RESX.Buttons.btnSave}
        onClick={saveConfiguration}
      />
    </div>
  </Modal>
}